import { FC } from 'react'
import Link from 'next/link'
import styles from './index.module.scss'
import { IArticleBase } from '../../../types'
import { getArticleThumbnail, getDateTimeFromUtc } from '../../../utils'
import { CompanyLogoAndName } from '../CompanyLogoAndName'
import LikeSvg from '../../../public/images/common/like.svg'
import { UserAvatarAndName } from '../UserAvatarAndName'

type Props = {
  article: IArticleBase
  withLink?: boolean
}

export const ArticleItem: FC<Props> = ({ article, withLink = false }) => {
  return (
    <Link href={`/articles/${article?.slug}`}>
      <a className={styles.container}>
        <div className={styles.thumbnail}>
          <img src={getArticleThumbnail(article)} alt={article?.title} className='img-fluid' />
        </div>
        <div className={styles.content}>
          <p className={styles.title}>{article?.title}</p>
          <p className={styles.meta}>{getDateTimeFromUtc(article.createdAt, 'YYYY.MM.DD')}</p>
          {article?.category.slug === 'stories' && withLink && (
            <div className={styles.companyAndLike}>
              {article?.company ? (
                <CompanyLogoAndName company={article?.company} />
              ) : (
                <UserAvatarAndName user={article?.opinionsUser} />
              )}
              <div className={styles.likeContainer}>
                <div className={styles.like}>
                  <LikeSvg />
                </div>
                <span className={styles.count}>{article.likedUsersCount}</span>
              </div>
            </div>
          )}
        </div>
      </a>
    </Link>
  )
}
